const themeColors = {
	GREY: "var(--color-text-muted)",
	GREY_FADED: "var(--color-grey-faded)",
	ORANGE: "var(--color-orange)",
	BLUE: "var(--color-blue)",
	BLUE_FADED: "var(--color-blue-faded)",
	GREEN: "var(--color-green)",
	GREEN_FADED: "var(--color-green-faded)",
	RED: "var(--color-red)",
	RED_FADED: "var(--color-red-faded)",
	BLACK: "var(--color-text)",
	WHITE: "#ffffff",
	BORDER: "var(--color-border)",
	TEXT: "var(--color-text)",
};

export default themeColors;
